import { fromZonedTime, toZonedTime } from 'date-fns-tz';
import { ITimezoneOption } from 'react-timezone-select';

export const formatDate = (date: Date): string => {
  return date.toLocaleDateString('default', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
};

export const calculateTimestamp = (
  date: Date | null,
  time: Date | null,
  timezone: ITimezoneOption
): number => {
  if (!date || !time) return 0;

  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const hours = time.getHours();
  const minutes = time.getMinutes();

  const combined = new Date(year, month, day, hours, minutes, 0);

  const zonedDate = fromZonedTime(combined, timezone.value);
  return zonedDate.getTime() / 1000;
};

export const getTimeFromTimestamp = (timestamp: number, timezone: string): Date => {
  const utcDate = new Date(timestamp * 1000);
  return toZonedTime(utcDate, timezone);
};

export const formatTimeFromTimestamp = (timestamp: number, timezone: string): string => {
  const utcDate = new Date(timestamp * 1000);
  const zonedDate = toZonedTime(utcDate, timezone);

  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  };

  return zonedDate.toLocaleString('en-US', options);
};

export const getTimezoneName = (timezoneString: string): string => {
  const formatter = new Intl.DateTimeFormat('en', {
    timeZone: timezoneString,
    timeZoneName: 'longGeneric'
  });

  const parts = formatter.formatToParts(new Date());
  const offsetPart = parts.find((part) => part.type === 'timeZoneName');

  return offsetPart?.value || 'GMT+0';
};

export const getGMTFromTimezone = (timezoneString: string): string => {
  const formatter = new Intl.DateTimeFormat('en', {
    timeZone: timezoneString,
    timeZoneName: 'shortOffset'
  });

  const parts = formatter.formatToParts(new Date());
  const offsetPart = parts.find((part) => part.type === 'timeZoneName');

  return offsetPart?.value || 'GMT+0';
};
